import { Box, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "@quest_editor/components/SectionHeader";

const EstimateSection = () => {
  const { t } = useTranslation("questEditor");

  return (
    <Paper
      elevation={0}
      sx={{ border: 1, borderColor: "divider", minHeight: 150 }}
    >
      <SectionHeader title={t("quest_estimate.section.estimate")} />
      <Box sx={{ p: 2 }}></Box>
    </Paper>
  );
};

export default EstimateSection;
